<div class="stepper-container">
  <div
    *ngFor="let step of steps; let i = index"
    class="step"
    [ngClass]="step.status"
  >
    <button
      class="number"
      [disabled]="
        step.status == Status.Locked ||
        step.status == Status.Pending ||
        step.status == Status.Current
      "
      [routerLink]="[step.path]"
    >
      {{ i + 1 }}
    </button>
    <div class="label">{{ step.title }}</div>
  </div>
</div>
